import React, { useState, useRef, useEffect } from 'react';
import './TwoLevelDropdown.css';

const TwoLevelDropdown = ({ menuItems, onSelect }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();

    const handleDocumentClick = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleDocumentClick);
        return () => document.removeEventListener('mousedown', handleDocumentClick);
    }, []);

    return (
        <div className="dropdown custom-dropdown" ref={dropdownRef}>
            <i
                className="fa-solid fa-check-square icon-button"
                onClick={() => setOpen(!open)}
                style={{ fontSize: '20px', cursor: 'pointer' }}
            ></i>

            {open && (
                <ul className="dropdown-menu show">
                    {menuItems.map((main) =>
                        main.subMenus?.length ? (
                            <li key={main.value} className="dropdown-submenu position-relative">
                                <a href="#" className="dropdown-item dropdown-toggle" onClick={(e) => e.preventDefault()}>
                                    {main.text}
                                </a>
                                <ul className="dropdown-menu start-100 top-0 mt-0">
                                    {main.subMenus.map((sub) => (
                                        <li key={sub.value}>
                                            <a
                                                href="#"
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setOpen(false);
                                                    onSelect(`${main.value}_${sub.value}`);
                                                }}
                                            >
                                                {sub.text}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ) : (
                            <li key={main.value}>
                                <a
                                    href="#"
                                    className="dropdown-item"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setOpen(false);
                                        onSelect(main.value);
                                    }}
                                >
                                    {main.text}
                                </a>
                            </li>
                        )
                    )}
                </ul>
            )}
        </div>
    );
};

export default TwoLevelDropdown;
